import { forwardRef } from 'react';
import { Icon } from '@/components/foundations';
import { Button } from '@/components/forms';
import { ConnectionCard } from '@/components/data';

export type WooCommerceStatus = 'ready' | 'connected';

export type WooCommerceCardProps = {
  status?: WooCommerceStatus;
  onConfigure?: () => void;
  className?: string;
};

const STATUS_TEXT: Record<WooCommerceStatus, string> = { ready: 'Pronto para conectar', connected: 'Conectado' };

/** Plugin WooCommerce (cabeçalho `.woo` com o logo, sobre o `ConnectionCard`). */
export const WooCommerceCard = forwardRef<HTMLElement, WooCommerceCardProps>(function WooCommerceCard({ status = 'ready', onConfigure, className }, ref) {
  return (
    <ConnectionCard
      ref={ref}
      id="plugins"
      className={className}
      head={
        <div className="woo"><svg className="woologo" viewBox="0 0 64 48" aria-label="WooCommerce"><path d="M6 2h52a5 5 0 0 1 5 5v22a5 5 0 0 1-5 5H38l5 11-14-11H6a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5z" fill="#7f54b3" /><text x="32" y="25" textAnchor="middle" fontFamily="DM Sans,Arial,sans-serif" fontWeight="800" fontSize="17" fill="#fff" letterSpacing="-.5">Woo</text></svg><div><h2>WooCommerce</h2><div className="okline"><Icon name="checkc" />{STATUS_TEXT[status]}</div></div></div>
      }
    >
      <div className="woo-row"><p>Conecte sua loja WooCommerce e comece a aceitar pagamentos com Lisboon.</p><Button variant="outline-navy" icon="plug" onClick={onConfigure} style={{ height: '64px', padding: '0 26px', fontWeight: '500', fontSize: '16.5px' }}>Configurar plugin</Button></div>
    </ConnectionCard>
  );
});
